module.exports = __webpack_public_path__ + "img/subwayRunner.a5a3ee61.png";